module.exports = __webpack_public_path__ + "img/dashbord-clock.d6edc76c.svg";